import * as actionTypes from './actionTypes';
import * as actions from './index';
import { makeCustomId } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

export const getDeletedEventRoomsStart = () => {
    return {
        type: actionTypes.EVENTROOMS_GET_DELETED_PROJECTS_START
    }
}

export const getDeletedEventRoomsSuccess = (projects) => {
    return {
        type: actionTypes.EVENTROOMS_GET_DELETED_PROJECTS_SUCCESS,
        deletedProjects: projects
    }
};

export const getDeletedEventRoomsFail = (error) => {
    return {
        type: actionTypes.EVENTROOMS_GET_DELETED_PROJECTS_FAIL,
        error: error
    };
};

export const getDeletedEventRooms = () => {
    return dispatch => {
        window.flow.getProjectsByFields([{ field: "projecttype", type: '=', value: 'project_delete', 'order': 'name' }])
            .then(res => {
                dispatch(getDeletedEventRoomsSuccess(res.project.elements));
            }).catch(res => {
                dispatch(getDeletedEventRoomsFail(res.message));
                dispatch(actions.applicationError(res.message));
            });
    };
}


export const newEventRoomStart = () => {
    return {
        type: actionTypes.EVENTROOMS_NEW_PROJECT_START
    }
}

export const newEventRoomSuccess = (project) => {
    return {
        type: actionTypes.EVENTROOMS_NEW_PROJECT_SUCCESS,
        payload: { project: project }
    }
}

export const newEventRoomFail = (error) => {
    return {
        type: actionTypes.EVENTROOMS_NEW_PROJECT_FAIL,
        error: error
    }
}


export const setActiveEventRoom = (id) => {
    return ({
        type: actionTypes.EVENTROOMS_SET_ACTIVE_PROJECT,
        payload: { activeProject: id }
    });
}

const addClipsToEventRoomSuccess = (projectId, clipIds) => {
    return {
        type: actionTypes.EVENTROOMS_ADD_CLIPS_TO_PROJECT_SUCCESS,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const addClipsToEventRoomStart = (projectId, clipIds) => {
    return {
        type: actionTypes.EVENTROOMS_ADD_CLIPS_TO_PROJECT_START,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const addClipsToEventRoomFail = (projectId, clipIds) => {
    return {
        type: actionTypes.EVENTROOMS_ADD_CLIPS_TO_PROJECT_FAIL,
        error: 'Could not add clips',
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

export const addClipsToEventRoom = (projectId, clipIds, type) => {
    return ((dispatch, getState) => {
        dispatch(addClipsToEventRoomStart(projectId, clipIds));
        window.flow.projectAddClip(projectId, clipIds, 'addtop').then(res => {
            dispatch(addClipsToEventRoomSuccess(projectId, clipIds));
        }).catch(res => {
            console.log(res);
            dispatch(addClipsToEventRoomFail(projectId, clipIds));
            dispatch(actions.addMessage('popup.title.project.add.fail', null, 'text', 'dialog'));
        });
    });
}

const removeClipsFromEventRoomSuccess = (projectId, clipIds) => {
    return {
        type: actionTypes.EVENTROOMS_REMOVE_CLIPS_FROM_PROJECT_SUCCESS,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const removeClipsFromEventRoomStart = (projectId, clipIds) => {
    return {
        type: actionTypes.EVENTROOMS_REMOVE_CLIPS_FROM_PROJECT_START,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const removeClipsFromEventRoomFail = (projectId, clipIds) => {
    return {
        type: actionTypes.EVENTROOMS_REMOVE_CLIPS_FROM_PROJECT_FAIL,
        error: 'Could not remove clips',
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

export const removeClipsFromEventRoom = (projectId, clipIds) => {
    return ((dispatch, getState) => {
        dispatch(removeClipsFromEventRoomStart(projectId, clipIds));
        window.flow.projectRemoveClipById(projectId, clipIds).then(res => {
            dispatch(removeClipsFromEventRoomSuccess(projectId, clipIds));
            dispatch(actions.getEventRoomTree());
            // dispatch(actions.getEventRooms());
            dispatch(actions.addMessage('popup.title.project.remove.success', null, 'text', 'dialog'));
        }).catch(res => {
            console.log(res);
            dispatch(removeClipsFromEventRoomFail(projectId, clipIds));
            dispatch(actions.addMessage('popup.title.project.remove.fail', null, 'text', 'dialog'));
        });
    });
}

export const deleteEventRoom = (projectId) => {
    console.log("LOGS: deleteEventRoom projectdId", projectId);
    return (dispatch => {
        dispatch({ type: actionTypes.EVENTROOMS_DELETE_PROJECT_START });
        window.flow.delProject(projectId).then(res => {
            console.log("LOGS: deleteEventRoom res", res);
            dispatch(actions.addMessage('popup.title.eventroom.delete.success', null, 'text', 'dialog'));
            dispatch({ type: actionTypes.EVENTROOMS_DELETE_PROJECT_SUCCESS, payload: { projectId: projectId } });
            dispatch(actions.getEventRoomTree());
            //dispatch(actions.getProjects());
        }).catch(res => {
            dispatch(actions.addMessage('popup.title.project.delete.fail', null, 'text', 'dialog'));
            dispatch({ type: actionTypes.EVENTROOMS_DELETE_PROJECT_FAIL });
        });
    });
}

export const removeEventRoomLinks = (projectId) => {
    return (dispatch => {
        dispatch({ type: actionTypes.EVENTROOMS_PROJECT_REMOVE_LINKS_START });
        window.flow.projectRemoveLinks(projectId).then(res => {
            dispatch({ type: actionTypes.EVENTROOMS_PROJECT_REMOVE_LINKS_SUCCESS });
            setTimeout(() => dispatch(actions.getEventRoomTree()), 1000);
        }).catch(res => {
            dispatch({ type: actionTypes.EVENTROOMS_PROJECT_REMOVE_LINKS_FAIL });
        });
    });
}


export const setMetaLangEventRoom = (data) => {
    return {
        type: actionTypes.EVENTROOMS_SET_METALANG,
        payload: data
    }
}
//OK
export function saveNewEventRoom(obj) {
    let customid = makeCustomId(12);
    let titleValue = obj.title_value ? obj.title_value : obj;
    return (dispatch => {
        dispatch(newEventRoomStart());
        window.flow.newDistproject("pmdb_eventroom", 0, { title: titleValue, title_de: titleValue, customid })
            .then(res => {
                console.log("LOGS: saveNewEventRoom res", res);
                dispatch(newEventRoomSuccess(res));
                setTimeout(() => {
                    dispatch(actions.getEventRoomTree());
                    if (res.data) dispatch(actions.setNewData({ project: { ...res.data, name: res.name } }));
                }, 2000);
            }).catch(err => {
                dispatch(newEventRoomFail(err.message));
                dispatch(actions.applicationError(err.message));
            })
    })
}


export const setCurrentEventRoom = (data) => {
    return {
        type: actionTypes.EVENTROOMS_SET_CURRENT_UPLOADPROJECT,
        payload: data
    }
}

//OK
export const updateEventRoomMetadata = ({ id, metadata }) => {
    console.log("LOGS: updateEventRoomMetadata id metadata", id, metadata);
    return dispatch => {
        dispatch({ type: actionTypes.EVENTROOMS_SET_LOADING, payload: { loading: true } });
        window.flow.editDistproject(id, metadata)
            .then((project) => {
                console.log("LOGS: updateEventRoomMetadata project", project);
                dispatch({ type: actionTypes.EVENTROOMS_SET_LOADING, payload: { loading: false } });
                dispatch(actions.getEventRoomTree());
            }).catch((res) => {
                console.log(res);
                dispatch({ type: actionTypes.EVENTROOMS_SET_LOADING, payload: { loading: false } });
            });
    }
}

export const addMemberToEventRoom = (id, member) => {
    return ((dispatch) => {
        dispatch({ type: actionTypes.ADD_MEMBER_PROJECT_START });
        dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectAddMember(id, member).then((project) => {
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            dispatch(actions.getEventRoomTree());
        }).catch((res) => {
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
        });
    });
}

export const delMemberFromEventRoom = (projectId, memberId) => {
    console.log("LAMTEST delMemberFromEventRoom projectId memberId", projectId);
    return ((dispatch) => {
        dispatch({ type: actionTypes.DELETE_MEMBER_PROJECT_START });
        dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectDelMember(projectId, memberId).then(project => {
            console.log("LAMEST delMemberFromEventRoom project", project);
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            dispatch(actions.getEventRoomTree());
        }).catch(res => {
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
        })
    })
}
